/** Обрезан ли текст элемента или любого его потомка многоточием. */
export function isTruncated(element: HTMLElement): boolean {
  return [element, ...element.querySelectorAll<HTMLElement>("*")].some(
    (node) => node.scrollWidth > node.clientWidth
  );
}
